export default __webpack_public_path__ + "static/media/man.2e482fe5.svg";